/* eslint-disable import/prefer-default-export */
import type { RuleTree, UUID } from 'types';

export const checkForChildren = (arrayTree: RuleTree[], selectedId: UUID): boolean =>
  arrayTree.some((node) => node.parent.includes(selectedId));
